import React, { useRef, useState } from 'react';
import './css/PlaylistTool.css';
import { IconButton } from './IconButton';
import { cmsAccount, jsonHeaders, msHeaders } from './NavMenu';
import { useEffect } from 'react';
import { flushSync } from 'react-dom';
import { Seperator } from './Seperator';

export function PlaylistTool({ selectedPlaylist, playlistClick, openPreviewer }) {
    const listRef = useRef();
    const [playlists, setPlaylists] = useState([]);

    useEffect(() => {
        const intervalId = setInterval(() => {
            if (cmsAccount) {
                fetchPlaylists();
                clearInterval(intervalId);
            }
        }, 100);
    }, [])

    function fetchPlaylists() {
        var requestOptions = {
            method: 'GET',
            headers: jsonHeaders,
            redirect: 'follow'
        };
        return fetch(`/api/playlists/`, requestOptions)
            .then(response => response.json())
            .then(result => {
                flushSync(() => {
                    setPlaylists(result);
                })
            })
    }

    function addPlaylist() {
        const name = prompt("Please enter playlist's name.");
        if (name == null)
            return;

        var requestOptions = {
            method: 'POST',
            headers: jsonHeaders,
            body: JSON.stringify({
                name: name,
                companyUUID: cmsAccount.companyUUID,
                orientation: 0
            }),
            redirect: 'follow'
        };

        fetch(`/api/playlists/`, requestOptions)
            .then(response => response.json())
            .then(result => {
                fetchPlaylists().then(() => {
                    listRef.current?.lastElementChild?.scrollIntoView({ behavior: 'smooth' });
                    playlistClick(result.uuid);
                })
            })
    }

    function renamePlaylist() {
        if (!selectedPlaylist)
            return;
        const name = playlists.find(p => p.uuid == selectedPlaylist).name;
        const newName = prompt("Enter a new name of the playlist:", name);
        if (!newName)
            return;

        var requestOptions = {
            method: 'PUT',
            headers: jsonHeaders,
            body: JSON.stringify({ name: newName }),
            redirect: 'follow'
        };

        fetch(`/api/playlists/${selectedPlaylist}`, requestOptions)
            .then(response => response.json())
            .then(result => {
                console.log(result)
                fetchPlaylists();
            })
            .catch(error => console.log('error', error));
    }

    function deletePlaylist() {
        var requestOptions = {
            method: 'DELETE',
            headers: msHeaders,
            redirect: 'follow'
        };
        fetch(`/api/playlists/${selectedPlaylist}`, requestOptions)
            .then(response => response.json())
            .then(result => {
                fetchPlaylists();
            })
            .catch(error => console.log('error', error));
    }
    return (
        <>
            <div className="playlist-list">
                <div className="top-bar">
                    <div className="playlist-name">
                        <div className="text">
                            Playlist Name
                        </div>
                    </div>
                    <Seperator height={16} style={{ marginLeft: "176px" }} />
                    <div className="last-edit">
                        <div className="text">
                            Last Edit Date
                        </div>
                    </div>
                </div>
                <div className="playlist-set" id="playlist-set" ref={listRef}>
                    {playlists.map((playlist, index) => {
                        return (
                            <div key={index} className="playlist-item-container">
                                <div className="playlist-mark-item" onClick={() => { playlistClick(playlist.uuid) }}>
                                    <div className="mark-color">
                                        <img src="icons/status-disabled.svg" />
                                    </div>
                                    <div className={selectedPlaylist == playlist.uuid ? "playlist-item-selected" : "playlist-item"}>
                                        <div className="component-1" style={{ display: selectedPlaylist == playlist.uuid ? "flex" : "none" }}>
                                            <img src="icons/arrow-right-normal.svg" />
                                        </div>
                                        <div className="playlist-name-container">
                                            <div
                                                className="playlist-name-text"
                                                id={`playlist-name-${playlist.uuid}`}
                                                playlistid={playlist.uuid}
                                                value="playlistName"
                                                onBlur={() => { "inputBlur(this)" }}>
                                                {playlist.name}
                                            </div>
                                        </div>
                                        <div className="last-edit-container">
                                            <div className="last-edit-text">
                                                {new Date(new Date(playlist.dateModified).getTime() - new Date().getTimezoneOffset() * 60000).toLocaleString()}
                                            </div>
                                        </div>
                                    </div>
                                </div >
                                <Seperator width={395} />
                            </div>
                        )
                    })}

                </div>
                <div className="bottom-bar">
                    <div className="tool-bar-2">
                        <IconButton
                            onClick={() => { addPlaylist() }}
                            src="icons/add-playlist.svg"
                            srcWhite="icons/add-playlist-white.svg"
                        />
                        {/* <IconButton
                            src="icons/copy.svg"
                            srcWhite="icons/copy-white.svg"
                        /> */}
                        <IconButton
                            onClick={() => { renamePlaylist() }}
                            src="icons/edit.svg"
                            srcWhite="icons/edit-white.svg"
                        />
                        <IconButton
                            onClick={() => { deletePlaylist() }}
                            src="icons/delete.svg"
                            srcWhite="icons/delete-white.svg"
                        />
                        <Seperator height={16} />
                        <IconButton
                            onClick={() => { openPreviewer() }}
                            src="icons/preview.svg"
                            srcWhite="icons/preview-white.svg"
                        />
                        {/* <IconButton
                            onClick={() => { "usb()" }}
                            src="icons/usb.svg"
                            srcWhite="icons/usb-white.svg"
                        />
                        <IconButton
                            onClick={() => { "download()" }}
                            src="icons/download.svg"
                            srcWhite="icons/download-white.svg"
                        /> */}
                        <iframe id="my_iframe" style={{ display: "none" }} ></iframe>
                    </div>
                </div>
            </div>

        </>
    )
}

